import { render, staticRenderFns } from "./filter-goods.vue?vue&type=template&id=185d2b01&scoped=true"
import script from "./filter-goods.vue?vue&type=script&lang=js"
export * from "./filter-goods.vue?vue&type=script&lang=js"
import style0 from "./filter-goods.vue?vue&type=style&index=0&id=185d2b01&prod&scoped=true&lang=scss"
import style1 from "./filter-goods.vue?vue&type=style&index=1&id=185d2b01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.32_css-loader@6.11.0_webpack@5.105.4__lodash@4.18.1__yidcnbbritke6h73lk2rhpn7vi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185d2b01",
  null
  
)

export default component.exports